import { toast } from 'react-toastify';

export const ShowNotification = (type, content, title) => {
  switch (type) {
    case 'success':
      toast.success(content, title, 3500);
      break;
    case 'error':
      toast.error(content, title, 3500);
      break;
    case 'info':
      toast.info(content, title, 3500);
      break;
    case 'warning':
      toast.warning(content, title, 3500);
      break;
    default:
      break;
  }
};


export default toast;